export const ONE_HUNDRED_PRICE_ID = "4a8c2e7b";
export const ONE_HUNDRED_RECURRING_PRICE_ID = "price_1QWFkhHpnEMU7Ru9WM28EEB1";

export const Plans = {
    YEAR: "year",
    MONTH: "month",
};